import React, { Fragment } from "react";
import { useForm } from "react-hook-form";
import {
  Row,
  Col,
  CardHeader,
  CardBody,
  CardFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Container,
  Button,
} from "reactstrap";
import Breadcrumbs from "../../Components/Common/Breadcrumb";
import JobDetails from "../../Components/Public/JobDetail/JobDetails";

const PublicJobDetailPage = () => {
  return (
    <Fragment>
      <Container fluid={true}>
        <JobDetails />
      </Container>
    </Fragment>
  );
};

export default PublicJobDetailPage;
